var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 18,
    fill: "#EE5D50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5998 42.6H27.5998C26.2743 42.6 25.1998 41.5254 25.1998 40.2L25.1999 25.8C25.1999 24.4745 26.2744 23.4 27.5999 23.4H38.4002C39.7257 23.4 40.8002 24.4745 40.8002 25.8V30M36.0002 36.5479C36.0002 35.2512 37.0747 34.2 38.4002 34.2C39.7257 34.2 40.8002 35.2512 40.8002 36.5479C40.8002 37.8446 39.7257 38.8958 38.4002 38.8958M38.4002 42.0903V42",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.ef8f9a11f297ab61d90e0775dac1fb91.svg";
export { ForwardRef as ReactComponent };